import React from 'react';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-charcoal pt-20 pb-10" data-id="element-1166">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1167">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16" data-id="element-1168">
          <div data-id="element-1169">
            <h3 className="text-2xl font-bold mb-6 text-white" data-id="element-1170">Kivarro</h3>
            <p className="text-white/80 mb-6 text-lg" data-id="element-1171">
              Accredited compliance training, workplace skills, and business
              courses across Ireland, the UK, and Europe.
            </p>
            <div className="flex space-x-4" data-id="element-1172">
              <a href="https://facebook.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-1173">
                <FacebookIcon size={20} data-id="element-1174" />
              </a>
              <a href="https://twitter.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-1175">
                <TwitterIcon size={20} data-id="element-1176" />
              </a>
              <a href="https://linkedin.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-1177">
                <LinkedinIcon size={20} data-id="element-1178" />
              </a>
              <a href="https://instagram.com" className="text-white/70 hover:text-teal transition-colors" data-id="element-1179">
                <InstagramIcon size={20} data-id="element-1180" />
              </a>
            </div>
          </div>
          <div data-id="element-1181">
            <h4 className="text-xl font-semibold mb-6 text-white" data-id="element-1182">Training</h4>
            <ul className="space-y-4" data-id="element-1183">
              <li data-id="element-1184">
                <a href="/compliance" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1185">
                  Compliance Training
                </a>
              </li>
              <li data-id="element-1186">
                <a href="/workplace" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1187">
                  Workplace & HR
                </a>
              </li>
              <li data-id="element-1188">
                <a href="/business" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1189">
                  Business Skills
                </a>
              </li>
              <li data-id="element-1190">
                <a href="/programs" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1191">
                  Compliance Programs
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-1192">
            <h4 className="text-xl font-semibold mb-6 text-white" data-id="element-1193">Resources</h4>
            <ul className="space-y-4" data-id="element-1194">
              <li data-id="element-1195">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1196">
                  Free Checklists
                </a>
              </li>
              <li data-id="element-1197">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1198">
                  Compliance Trackers
                </a>
              </li>
              <li data-id="element-1199">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1200">
                  Audit Templates
                </a>
              </li>
              <li data-id="element-1201">
                <a href="/resources" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1202">
                  Premium Bundles
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-1203">
            <h4 className="text-xl font-semibold mb-6 text-white" data-id="element-1204">Contact</h4>
            <ul className="space-y-4" data-id="element-1205">
              <li data-id="element-1206">
                <a href="/contact" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1207">
                  Contact Us
                </a>
              </li>
              <li data-id="element-1208">
                <a href="/support" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1209">
                  Support
                </a>
              </li>
              <li data-id="element-1210">
                <a href="/faq" className="text-white/80 hover:text-teal transition-colors text-lg" data-id="element-1211">
                  FAQs
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-10 mb-10 border-t border-b border-white/10 py-10" data-id="element-1212">
          <div className="text-white/40 font-medium" data-id="element-1213">CPD Certified</div>
          <div className="text-white/40 font-medium" data-id="element-1214">ROSPA Approved</div>
          <div className="text-white/40 font-medium" data-id="element-1215">
            Irish Trade Federation
          </div>
        </div>
        <div className="pt-6" data-id="element-1216">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-1217">
            <p className="text-white/50 text-sm mb-4 md:mb-0" data-id="element-1218">
              &copy; {new Date().getFullYear()} Kivarro. All rights reserved.
            </p>
            <div className="flex space-x-8" data-id="element-1219">
              <a href="/terms" className="text-white/50 hover:text-teal text-sm transition-colors" data-id="element-1220">
                Terms
              </a>
              <a href="/privacy" className="text-white/50 hover:text-teal text-sm transition-colors" data-id="element-1221">
                Privacy
              </a>
              <a href="/cookies" className="text-white/50 hover:text-teal text-sm transition-colors" data-id="element-1222">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};